var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.451 6.25a.85.85 0 0 1 0 1.201l-10 10a.85.85 0 0 1-1.202 0l-4-4a.85.85 0 1 1 1.202-1.202l3.399 3.399 9.399-9.399a.85.85 0 0 1 1.202 0",
  clipRule: "evenodd"
})));
export default SvgCheck;